/* eslint-disable react/prop-types */
import React from "react";
import styled from "@emotion/styled";
import Div100vh from "react-div-100vh";
import ImgBackgroundProduct from "../Images/Journal/ImgBackgroundProduct";
import FireFly from "../Animations/FireFly";
import FeaturesProduct from "../Features/FeaturesProduct";

// Config
// import { css } from "@emotion/core";
// import { colors, contact, mediaQueries } from "../../configs/_configSite";

const ContainerMain = styled(Div100vh)`
  position: relative;
  height: 100vh;
  width: 100vw;
  background: green;
`;

export default ({ data }) => {
  return (
    <ContainerMain>
      <ImgBackgroundProduct />
      <FireFly />
      <FeaturesProduct data={data} />
    </ContainerMain>
  );
};
